module.exports = __webpack_public_path__ + "img/metal_u@2x.8f4e4963.png";